var React = require('react');

function BulletCheckWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.57,2.84A1.43,1.43,0,0,1,24,3.89,1.43,1.43,0,0,1,23.57,5L12.36,16.16l-2.11,2.1a1.48,1.48,0,0,1-2.11,0L6,16.16.43,10.55a1.5,1.5,0,0,1,0-2.1L2.54,6.34a1.43,1.43,0,0,1,1-.43,1.45,1.45,0,0,1,1.06.43L9.2,10.91,19.35.74a1.48,1.48,0,0,1,2.11,0l2.11,2.1Z","style":{"fill":"#fff"}}));
}

BulletCheckWhite.defaultProps = {"viewBox":"0 0 24 19"};

module.exports = BulletCheckWhite;

BulletCheckWhite.default = BulletCheckWhite;
